import apiFetch from '../../../utils/apiFetch';
export const consumeGuidingBolt = async (campaignId, input) => {
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/spell-riders/guiding-bolt/consume`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(input),
  });
  const result = await response.json(); if (!response.ok) throw new Error(result.message || 'Guiding Bolt could not authorize this attack.');
  return result;
};

// One authorization request settles both attacker-side penalties and target marks.
export const consumeSpellAttackEffects = async (campaignId, input) => {
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/spell-riders/attack-roll/consume`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(input),
  });
  const result = await response.json(); if (!response.ok) throw new Error(result.message || 'Spell effects could not authorize this attack.');
  return result;
};
